import { useMutation } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { IVerifyQueryParamsType, IVerifyResponseType } from './type'
import { IResponseType } from '@/types/response-type'

export function useVerify({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<IVerifyQueryParamsType>) {
  return useMutation({
    mutationFn: async () => {
      const response = await APIInstance<IVerifyResponseType>({
        url: 'user/login/',
        method: 'post',
        data
      })
      return response.data
    },
    mutationKey: ['verify-otp', data],
    retry: 0,
    ...rest
  })
}
